module.exports = __webpack_public_path__ + "img/YesNo.ae9aaeb0.svg";